import { Component, Inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';
import { MoovDefinition } from '../../models/moovDefinition';
import { MoovStep } from '../../models/moovStep';
import { AppService } from '../../app.service';

@Component({ standalone:false,
  selector: 'app-missing-required-parameters',
  templateUrl: './missing-required-parameters-dialog.component.html',
  styleUrl: './missing-required-parameters-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class MissingRequiredParametersDialogComponent {
  title: string="Title";
  message: string="";
  confirmButtonText="OK";

  public moovDefinition!:MoovDefinition;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<ConfirmationDialogComponent>,private appService:AppService,){
    if(data){
      this.title=data.title;
      this.message = data.message || this.message;
      this.moovDefinition=data.moovDefinition;
      if(data.buttonText){
        this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
      }
    }
  }

  get missingRequiredParameters(){
    return this.moovDefinition?.steps?.filter(s=>s.missingMandatoryParameters.length>0);
  }

  public getMoovStepType(ms:MoovStep){
    return(ms?.moovStepDefinition)?this.appService.getMoovStepType(ms.moovStepDefinition.stepType):'';
  }

  onConfirmClick(): void{
    this.dialogRef.close(true);
  }
}
